import React, { FC } from "react";

import Monitoring from "../components/Monitoring";

const MonitoringPage: FC = () => <Monitoring/>;

export default MonitoringPage;
